import {useTemplate} from 'Event/TemplateProvider'
import styled from 'styled-components'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {onChangeCheckedHandler} from 'lib/dom'
import React from 'react'
import {EnabledSwitch} from 'lib/ui/form/Switch'

export function ToggleTechCheckSwitch() {
  const {techCheck} = useTemplate()
  const save = useSaveTemplate()

  const handleToggle = (isEnabled: boolean) => {
    save({
      techCheck: {
        isEnabled,
      },
    })
  }

  return (
    <StyledEnabledSwitch
      checked={techCheck.isEnabled}
      onChange={onChangeCheckedHandler(handleToggle)}
      aria-label="toggle tech check"
    />
  )
}

const StyledEnabledSwitch = styled(EnabledSwitch)`
  margin-bottom: 0;
`
